export default __webpack_public_path__ + "static/media/CCTV.8cd2d603.svg";